import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loader from './common/Loader';

const AdminRoute = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return <Loader />;
    }

    // Redirect to the regular home or admin login if not an admin user
    if (!user) {
        return <Navigate to="/hoommy_admin" replace />;
    }

    if (user.rol !== 'admin') {
        // If a regular user tries to access an admin route, send them to their dashboard
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default AdminRoute;
